var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var FormSection = /** @class */ (function (_super) {
            __extends(FormSection, _super);
            function FormSection(formService, dataSourceService, formSectionService, modalSerivce) {
                var _this = _super.call(this, formService, dataSourceService, formSectionService, modalSerivce) || this;
                _this.templateUrl = './app/views/directives/inputForm/formSection.html';
                _this.controller = ['$scope', 'formService', 'dataSourceService', 'formSectionService', 'ModalService', 'deleteService', 'securityMatrixService', '$rootScope', FormSectionController];
                return _this;
            }
            FormSection.prototype.link = function ($scope, element, attrs) { };
            return FormSection;
        }(directives.BaseGroup));
        directives.FormSection = FormSection;
        var FormSectionController = /** @class */ (function (_super) {
            __extends(FormSectionController, _super);
            function FormSectionController($scope, formService, dataSourceService, formSectionService, modalService, deleteService, securityMatrixService, $rootScope) {
                var _this = _super.call(this, $scope, formService, dataSourceService, formSectionService, modalService, deleteService, securityMatrixService) || this;
                _this.$rootScope = $rootScope;
                $scope.userActionInitiated = function (u) { return _this.userActionInitiated(u); };
                return _this;
                //if($scope.formSection.condition_id && $scope.process && !$scope.process.conditionStates[$scope.formSection.condition_id])
                // || ($scope.process.formsVisibilities[$scope.form.uniqueIdentifier] && Enumerable.from($scope.process.formsVisibilities[$scope.form.uniqueIdentifier].hiddenGroups).any(g=>g[))){
            }
            FormSectionController.prototype.userActionInitiated = function (userAction) {
                this.$rootScope.$broadcast('userActionInitated', userAction);
            };
            return FormSectionController;
        }(directives.BaseGroupController));
        directives.FormSectionController = FormSectionController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('FormSection', []);
